import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import {BreakdownFilter} from '../../models/filters/breakdown-filters';
import {BreakdownDTO} from '../../models/breakdown';
import {BreakdownService} from '../../services/breakdown.service';
import {BreakdownsDetailsComponent} from '../breakdowns-details/breakdowns-details.component';
import {BreakdownsCloseComponent} from '../breakdowns-close/breakdowns-close.component';
import {BikeService} from '../../services/bike.service';
import { fadeInAndOut } from '../../utils/animations-utils';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';
@Component({
  selector: 'app-accounts',
  animations: [fadeInAndOut()],
  templateUrl: './breakdowns-list.component.html',
  styleUrls: ['./breakdowns-list.component.css']
})
export class BreakdownsListComponent implements OnInit {

  p = 1;      // current page
  total: number;      // total count of records
  itemsPerPage = environment.itemPerPage;       // number of records to display on each page
  listLoading: boolean;
  downloading : boolean = false;

  filters: BreakdownFilter;
  listFiltered = false;
  statuses: string[];
  elements: string[];
  bikeTypes: string[];

  /**
   * Keys : string criterias
   * Values : boolean => true if ascending, false otherwise
   */
  sortingCriterias: Map<string, boolean> = new Map();

  /** Accounts to display in table */
  breakdowns: BreakdownDTO[];

  /** Data for modals */
  closureModal: NgbModalRef;
  detailsModal: NgbModalRef;

  constructor(private breakdownService: BreakdownService,
              private bikeService: BikeService,
              private modalService: NgbModal,
              private translate : TranslateService, 
              private toast : ToastsManager) {
  }

  /**
   * Loads a list of accounts to display in the table
   * Also loads a list of groups and sucbscription plans to display in the filters fields.
   */
  ngOnInit() {
    this.filters = new BreakdownFilter();
    this.breakdownService.getElements().subscribe(elements => this.elements = elements);
    this.breakdownService.getStatuses().subscribe(statuses => this.statuses = statuses);
    this.bikeService.getTypes().subscribe(bikeTypes => this.bikeTypes = bikeTypes);
    if (localStorage.getItem('itemsPerPage')) {
      this.itemsPerPage = parseInt(localStorage.getItem('itemsPerPage'));
    }
    this.getBreakdowns(1);
  }

  /**
   * Create a new empty object for filtering attachment points
   * Retrieve first page
   */
  clearFilters() {
    this.filters = new BreakdownFilter();
    this.listFiltered = false;
    this.reloadList();
  }

  /**
   * Sorting system function as follow
   * On first click on a criteria => add the criteria as ascending
   * On second click => put the critiera to descending
   * On third click => remove the criteria from the map
   */
  updateSortingCriterias(criteria: string) {
    if (this.sortingCriterias.has(criteria)) {
      if (this.sortingCriterias.get(criteria)) {   // criteria is present as true => switch to false
        this.sortingCriterias.set(criteria, !this.sortingCriterias.get(criteria));
      } else {    // criteria present as false => delete it
        this.sortingCriterias.delete(criteria);
      }
    } else {
      this.sortingCriterias.set(criteria, true);
    }
  }

  changeItemCount(value) {
    this.itemsPerPage = value;
    this.reloadList();

    localStorage.setItem('itemsPerPage', value);
  }

  sortBy(criteria: string) {
    this.updateSortingCriterias(criteria);
    this.reloadList();
  }

  /**
   * Reload lists according to filters, sorting criterias from the first page
   */
  reloadList() {
    this.listFiltered = false;
    Object.values(this.filters).forEach(value => {
      if (value) {
        this.listFiltered = true;
      }
    });
    this.getBreakdowns(1);
  }

  /**
   * Load all accounts
   */
  getBreakdowns(page: number): void {
    this.p = page;
    this.listLoading = true;

    this.breakdownService.getPaginatedFilteredSortedAccountsList(
      this.p,
      this.itemsPerPage,
      this.filters,
      this.sortingCriterias)
      .subscribe(data => {
        this.breakdowns = data.res;
        this.total = data.headers.get('x-total-count');
        this.listLoading = false;
      });
  }

  downloadXLSFile() {
    this.downloading = true;
    this.breakdownService.downloadXLSFile(
      this.p,
      this.itemsPerPage,
      this.filters,
      this.sortingCriterias)
      .subscribe(isTruncated => {
        if (isTruncated) {
          this.toast.warning(this.translate.instant('common.downloadOk'));
        } else {
          this.toast.success(this.translate.instant('common.downloadTruncated'));
        }
        this.downloading = false;
      });
  }

  onDetailsClick(breakdownId: number): void {
    this.breakdownService.getBreakdown(breakdownId).subscribe(breakdown => {
      this.detailsModal = this.modalService.open(BreakdownsDetailsComponent, {size: 'xxl' as 'lg', backdrop: 'static'});
      this.detailsModal.componentInstance.breakdown = breakdown;
    });
  }

  onCloseClick(breakdownId: number): void {
    this.closureModal = this.modalService.open(BreakdownsCloseComponent, {size: 'lg', backdrop: 'static'});
    this.closureModal.componentInstance.breakdownId = breakdownId;
    this.closureModal.componentInstance.onCloseValidation.subscribe(() => this.reloadList());
  }

  onWIPClick(breakdownId: number): void {
    this.breakdownService.patch({id: breakdownId, status: 'WIP'} as BreakdownDTO).subscribe(() => this.reloadList());
  }
}



// WEBPACK FOOTER //
// ./src/app/breakdowns/breakdowns-list/breakdowns-list.component.ts